<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" md="2" align-self="center" class="text-left">
        <p>{{ $t('page.consultation.filters.integrationDate') }}</p>
      </v-col>
      <v-col cols="12" sm="4" md="5">
        <input-date-picker
          :label="$t('page.consultation.filters.inputDateLabels.from')"
          :date="filters.from"
          :maxDate="filters.to"
          @input="setFilter('from', $event)"
        />
      </v-col>
      <v-col cols="12" sm="4" md="5">
        <input-date-picker
          :label="$t('page.consultation.filters.inputDateLabels.to')"
          :date="filters.to"
          :maxDate="maxDate"
          @input="setFilter('to', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2" align-self="center" class="text-left">
        <p>{{ $t('page.consultation.filters.circuits') }}</p>
      </v-col>
      <v-col v-for="(circuit, index) in filters.circuits" :key="index">
        <v-checkbox
          :input-value="circuit.selected"
          :label="circuit.label"
          @change="toggleCircuitFilter(index)"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="2" align-self="center" class="text-left">
        <p>{{ $t('page.consultation.filters.supplier') }} :</p>
      </v-col>
      <v-col cols="12" md="5">
        <input-digits
          :value="filters.supplierCode"
          :label="$t('page.consultation.filters.supplierFields.code')"
          :hideArrows="true"
          :clearable="true"
          :disabled="!!filters.supplierCorpName"
          @input="setFilter('supplierCode', $event)"
        />
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
          :value="filters.supplierCorpName"
          :label="$t('page.consultation.filters.supplierFields.name')"
          clearable
          :disabled="!!filters.supplierCode"
          @input="setFilter('supplierCorpName', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import InputDatePicker from '@/components/input-datepicker.vue';
import InputDigits from '@/components/interface/input-digits.vue';
import { purchaseConditionsFilters, toggleCircuitFilter, setFilter } from '@/modules/purchase-conditions';

export default Vue.extend({
  name: 'PurchaseConditionsFilters',
  components: {
    InputDatePicker,
    InputDigits
  },
  data: () => ({
    maxDate: new Date().toISOString()
  }),
  computed: {
    filters() {
      return purchaseConditionsFilters;
    }
  },
  methods: {
    setFilter,
    toggleCircuitFilter
  }
});
</script>
